import SurveySearch from "./surveySearch.container";

export default SurveySearch;